import SimpleCalendar from "lib/components/common/calendar/simple-calendar";
import ErrorBox from "lib/components/common/error-box";
import FlexBox from "lib/components/common/flex-box";
import SimpleStepper from "lib/components/common/stepper/simple-stepper";
import {
  DEFAULT_SELECTED_WEEKDAYS,
  SUBSCRIPTION_DURATIONS,
} from "lib/constants";
import { AppContext } from "lib/contexts/app-context";
import { getArrayFrom } from "lib/utils/array-utils";
import { FC, useContext, useMemo, useState } from "react";
import { Accordion, Button, Spinner } from "react-bootstrap";
import "react-day-picker/style.css";
import ROOM_BOOKING_SERVICE from "lib/services/room-booking-service";
import RoomBookingSummaryTile from "lib/components/practitioners/room-booking-summary-tile";
import { getFullName } from "lib/utils/util";
import { getLocalISO } from "lib/utils/date-utils";

interface SubscriptionsCartPartialPageProps {
  //subscription: SubscriptionDetails;
  //calendarDetails: CalendarDetails;
  practitioner: PractitionerDetails;
  clinicName?: string;
  roomNumber?: number;
  perDayPrice?: number;
  //practitionerName?: string;
  unavailableDays?: UnavailableDay[];
  unavailableDates: Date[];
  onCheckout?: (
    subscriptionCheckoutDetails: SubscriptionCheckoutDetails
  ) => void;
  loading?: boolean;
  error?: string | null;
  sundayDisabled?: boolean;
}

const SubscriptionsCartPartialPage: FC<SubscriptionsCartPartialPageProps> = ({
  //subscription,
  //calendarDetails,
  practitioner,
  clinicName,
  roomNumber,
  perDayPrice,
  //practitionerName,
  unavailableDays = [],
  unavailableDates = [],
  onCheckout,
  loading = false,
  error = null,
  sundayDisabled = false,
}) => {
  const { appState } = useContext(AppContext);
  const [selectedMonthIndex, setSelectedMonthIndex] = useState<number>(0);
  const [subscriptionStartDate, setSubscriptionStartDate] = useState<Date>(
    new Date()
  );

  const [selectedWeekdays, setSelectedWeekdays] = useState<string[]>(
    DEFAULT_SELECTED_WEEKDAYS
  );
  //const [billableDays, setBillableDays] = useState(0);

  const allSelectedDates = useMemo(
    () =>
      ROOM_BOOKING_SERVICE.getSelectableDates(
        new Date(subscriptionStartDate),
        unavailableDates,
        selectedWeekdays,
        SUBSCRIPTION_DURATIONS[selectedMonthIndex]
      ),
    [
      subscriptionStartDate,
      unavailableDates,
      selectedWeekdays,
      selectedMonthIndex,
    ]
  );

  // const allSelectedDates = useMemo(() => {
  //   const refStartDate = new Date(subscriptionStartDate);
  //   const startDate = new Date(refStartDate);
  //   const endDate = new Date(refStartDate);
  //   endDate.setMonth(
  //     refStartDate.getMonth() + SUBSCRIPTION_DURATIONS[selectedMonthIndex]
  //   );
  //   endDate.setDate(refStartDate.getDate() - 1);
  //   const d = getAllDatesBetween(startDate, endDate, selectedWeekdays);
  //   console.log(d.length);
  //   return d;
  // }, [
  //   SUBSCRIPTION_DURATIONS[selectedMonthIndex],
  //   subscriptionStartDate,
  //   selectedWeekdays,
  // ]);

  // const billableDates = useMemo(
  //   () => difference(allSelectedDates, unavailableDates),
  //   [allSelectedDates, unavailableDates]
  // );

  // useEffect(() => {
  //   const calculatedDays = countBillableDays(
  //     allSelectedDates,
  //     calendarDetails.unavailableDates
  //       .concat(calendarDetails.holidays)
  //       .map((d: UnavailableDay) => new Date(d.date))
  //   );
  //   setBillableDays(calculatedDays);
  // }, [
  //   allSelectedDates,
  //   calendarDetails.unavailableDates,
  //   calendarDetails.holidays,
  // ]);

  // const billableDays = billableDates?.length ?? 0;

  // const getCheckoutInfos = () => {
  //   return [
  //     {
  //       label: "No. Billable Days",
  //       value: `${billableDays}`,
  //     },
  //     {
  //       label: "Total Amount",
  //       //value: `£${billableDays * subscription.perDayPrice}`,
  //       value: `£${billableDays * 1}`,
  //     },
  //   ];
  // };

  // const getSubscriptionItems = (): SubscriptionCheckoutItem[] => {
  //   const dateRanges: { startDate: Date; endDate: Date }[] = [];
  //   let rangeStartDate = new Date(subscriptionStartDate);
  //   const numberOfPeriods = SUBSCRIPTION_DURATIONS[selectedMonthIndex] / 3;
  //   for (let i = 0; i < numberOfPeriods; i++) {
  //     const rangeEndDate = new Date(rangeStartDate);
  //     rangeEndDate.setMonth(rangeStartDate.getMonth() + 3);
  //     rangeEndDate.setDate(rangeEndDate.getDate() - 1);

  //     dateRanges.push({
  //       startDate: rangeStartDate,
  //       endDate: rangeEndDate,
  //     });

  //     rangeStartDate = new Date(rangeEndDate);
  //     rangeStartDate.setDate(rangeStartDate.getDate() + 1);
  //   }

  //   const items: SubscriptionCheckoutItem[] = getArrayFromTo(
  //     0,
  //     selectedMonthIndex
  //   ).map((index) => {
  //     const dates = getBillableDays(
  //       dateRanges[index].startDate,
  //       dateRanges[index].endDate,
  //       calendarDetails.unavailableDates
  //         .concat(calendarDetails.holidays)
  //         .map((unavailableDay) => new Date(unavailableDay.date)),
  //       selectedWeekdays
  //     ).map((date) => date.toISOString());
  //     return {
  //       name: subscription.title,
  //       price: subscription.perDayPrice * dates.length,
  //       description: subscription.sku,
  //       dates,
  //     };
  //   });
  //   return items;
  // };

  // const handleCheckoutClick = () => {
  //   const details: SubscriptionCheckoutDetails = {
  //     fromDate: allSelectedDates?.[0]?.toISOString(),
  //     toDate: allSelectedDates?.[allSelectedDates?.length - 1].toISOString(),
  //     subscriptionId: "",
  //     practitionerId: appState.user_id,
  //     practitionerEmail: practitioner?.email,
  //     practitionerName: getFullName(
  //       practitioner?.firstName,
  //       practitioner?.lastName
  //     ),
  //     dates: (allSelectedDates ?? []).map((date) => date.toISOString()),
  //     weekDays: selectedWeekdays,
  //     months: SUBSCRIPTION_DURATIONS[selectedMonthIndex],
  //   } as SubscriptionCheckoutDetails;
  //   onCheckout?.(details);
  // };
  const handleCheckoutClick = () => {
    const details: SubscriptionCheckoutDetails = {
      fromDate: getLocalISO(allSelectedDates?.[0]),
      toDate: getLocalISO(allSelectedDates?.[allSelectedDates.length - 1]),
      subscriptionId: "",
      practitionerId: appState.user_id,
      practitionerEmail: practitioner?.email,
      practitionerName: getFullName(
        practitioner?.firstName,
        practitioner?.lastName
      ),
      dates: (allSelectedDates ?? []).map((date) => getLocalISO(date)),
      weekDays: selectedWeekdays,
      months: SUBSCRIPTION_DURATIONS[selectedMonthIndex],
    } as SubscriptionCheckoutDetails;
    onCheckout?.(details);
  };

  console.log(subscriptionStartDate);

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <strong>Subscription Duration</strong>
        </Accordion.Header>
        <Accordion.Body>
          <SimpleStepper
            steps={getArrayFrom<string>(SUBSCRIPTION_DURATIONS).map(
              (month) => `${month} months`
            )}
            selectedStep={selectedMonthIndex}
            onClick={setSelectedMonthIndex}
          />
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <strong>Subscription Starts From</strong>
        </Accordion.Header>
        <Accordion.Body>
          <FlexBox justifyContent="center">
            <SimpleCalendar
              className="shadow"
              unavailableDays={unavailableDays}
              selectedDate={subscriptionStartDate}
              selectedDates={allSelectedDates}
              showWeekDaySelection={true}
              onWeekdayChange={(days) => {
                setSelectedWeekdays(days);
              }}
              selectedWeekdays={selectedWeekdays}
              onChange={setSubscriptionStartDate}
              disableSundays={sundayDisabled}
              // disabled={[
              //   new Date(new Date().setDate(new Date().getDate() - 1)),
              // ]}
            />
          </FlexBox>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>
          <strong>Checkout</strong>
        </Accordion.Header>
        <Accordion.Body>
          {/* {getCheckoutInfos().map((data: SelectOption) => (
            <Form.Group as={Row} className="mb-3" key={data.label}>
              <Form.Label column sm="4">
                <b>{data.label}:</b>
              </Form.Label>
              <Col sm="8">
                <Form.Control plaintext readOnly value={data.value} />
              </Col>
            </Form.Group>
          ))} */}
          <RoomBookingSummaryTile
            practitionerName={getFullName(
              practitioner?.firstName,
              practitioner?.lastName
            )}
            clinicName={clinicName || ""}
            roomNumber={roomNumber || 0}
            dates={allSelectedDates}
            pricePerDay={perDayPrice || 0} // Assuming a fixed price per day for simplicity
            isShowFromDateToDate
          />
          <Button
            variant="primary"
            className="w-100 rounded-pill fw-bold mt-3"
            onClick={handleCheckoutClick}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Checkout"}
          </Button>
          {error && <ErrorBox message={error} />}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default SubscriptionsCartPartialPage;
